import { Component, Input } from '@angular/core';

/**
 * Badge "Sustentable" de un [[SlotsBatch|Lote]], con el esquema de
 * sustentabilidad (2BSvs, EUDR, etc.) cuando está especificado.
 *
 * Usa un ícono de certificación y no la hoja, que ya identifica a la huella de
 * carbono ([[CarbonFootprintIconComponent]]).
 */
@Component({
  selector: 'ag-sustainable-badge',
  template: `<span *ngIf="quality?.sustainable" class="ag-label label-success"
    ><i class="material-symbols-rounded" aria-hidden="true">verified</i> {{ 'ORDER_FORM.PRODUCT.SUSTAINABLE'|translate }}<ng-container
    *ngIf="quality.sustainable_scheme?.id"> · {{ quality.sustainable_scheme.abbrev || quality.sustainable_scheme.name }}</ng-container></span>`,
  styles: [`
    .material-symbols-rounded { font-size: 1.2em; line-height: 0; vertical-align: -0.2em; }
  `]
})
export class SustainableBadgeComponent {

  @Input() public quality: { sustainable?: boolean, sustainable_scheme?: any };
}
